<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="12" style="margin:0px 0px 16px 0px;">
          <!-- <a-col class="a-large-form" >
            <a-form-item label="" style="margin-bottom:0px;width:100%">
              <a-input placeholder="请输入校区名称" v-model="queryParam.schoolDistrict"></a-input>
            </a-form-item>
          </a-col>   -->
          <a-col class="a-large-form">
            <a-form-item label="" style="margin-bottom:0px;width:100%">
              <!-- <a-input placeholder="请输入教师姓名" v-model="queryParam.realname"></a-input> -->
              <j-input placeholder="请输入教师姓名" v-model="queryParam.realname"></j-input>
            </a-form-item>
          </a-col>
          <a-col class="a-large-form" style="width:320px">
            <a-form-item style="margin-bottom:0px;width:300px" label="" :required="false">
              <!-- <j-multi-select-tag
              v-model="queryParam.skilled"
              placeholder="请选择擅长科目"
              dictCode="subjectSkill"
            /> -->
              <j-dict-select-tag v-model="queryParam.skilled" placeholder="请选择科目" dictCode="subject" />
            </a-form-item>
          </a-col>
          <!-- <a-col class="a-large-form" >
            <a-form-item label="" style="margin-bottom:0px;width:100%">
              <a-input placeholder="请输入教师手机" v-model="queryParam.phone"></a-input>
            </a-form-item>
          </a-col> -->

          <a-button type="primary" @click="searchQuery" style="margin-left:5px;vertical-align: middle;">筛选</a-button>
          <a-button @click="gameCreate()" type="primary" icon="plus" style="float:right;">新增教师</a-button>
        </a-row>
      </a-form>
    </div>
    <div>
      <a-table
        ref="table"
        size="middle"
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        @change="handleTableChange"
      >
        <div slot="userAvatar" slot-scope="text, record">
          <div class="userInfo-img">
            <img :src="record.avatar" alt width="50" />
          </div>
        </div>

        <span slot="action" slot-scope="text, record" style="width:200px">
          <a @click="gameEdite(record.id, record.gameType)">编辑</a>
          <!-- <a-divider type="vertical" />
          <a @click="handlePerssion(record.id,record.sysOrgCode)">课程权限</a> -->
          <a-divider type="vertical" />
          <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
            <a>删除</a>
          </a-popconfirm>
        </span>
      </a-table>
    </div>
    <teacher-role-modal ref="modalUserRole"></teacher-role-modal>
  </a-card>
</template>

<script>
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
// import { updateShelf } from '@/api/api'
import TeacherRoleModal from '@/components/teacherManagement/TeacherRoleModal'

export default {
  name: 'TeacherList',
  mixins: [JeecgListMixin],
  components: {
    TeacherRoleModal
  },
  data() {
    return {
      description: '教师管理',
      sex: '0',
      queryParam: {
        realname: '',
        phone: ''
      },
      // 表头
      columns: [
        {
          title: 'NO',
          align: 'center',
          dataIndex: 'orgCode',
          width: 100,
          customRender: (text, row, index) => {
            return <span>{index + 1}</span>
          }
        },
        {
          title: '头像',
          align: 'center',
          width: 100,
          scopedSlots: { customRender: 'userAvatar' }
        },
        {
          title: '姓名',
          align: 'center',
          dataIndex: 'realname',
          width: 150
          // sorter: true,
        },
        {
          title: '性别',
          align: 'center',
          dataIndex: 'sex_dictText',
          width: 100
        },
        // {
        //   title: '所属校区',
        //   align:"center",
        //   dataIndex: 'schoolDistrict',
        //   width:100

        // },
        {
          title: '科目',
          align: 'center',
          dataIndex: 'skilled_dictText',
          width: 100
        },
        {
          title: '手机号',
          align: 'center',
          dataIndex: 'phone',
          width: 150
        },
        // {
        //   title: '电子邮箱',
        //   align:"center",
        //   dataIndex: 'email',
        //   width:100
        // },
        {
          title: '更新时间',
          align: 'center',
          dataIndex: 'updateTime',
          width: 160,
          customRender: (text, row, index) => {
            if (text) {
              return text
            }
            return row.createTime
          }
        },
        // {
        //   title: '到期日期',
        //   align:"center",
        //   dataIndex: 'endDate',
        //   width:100
        // },
        // {
        //   title: '备注',
        //   align:"center",
        //   dataIndex: 'comment',
        //   width:100
        // },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' },
          width: 260
        }
      ],
      dataSource: [],
      // 请求参数
      url: {
        list: '/userInfo/teacher/list',
        delete: '/userInfo/teacher/delete'
        // deleteBatch: "/course/elinkxCourse/deleteBatch",
        // exportXlsUrl: "course/elinkxCourse/exportXls",
        // importExcelUrl: "course/elinkxCourse/importExcel",
      }
    }
  },
  computed: {
    importExcelUrl: function() {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
    }
  },

  methods: {
    // 创建图文
    gameCreate() {
      this.$router.push({ path: '/teacherManagement/TeacherCreate' })
    },
    gameEdite(id, type) {
      this.$router.push({ path: '/teacherManagement/TeacherCreate?id=' + id })
    },
    handlePerssion: function(roleId, sysOrgCode) {
      this.$refs.modalUserRole.show(roleId, sysOrgCode)
    }
  }
}
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>

<style lang="scss" scoped>
.userInfo-img {
  // float: left;
  text-align: center;
  width: 50px;
  height: 50px;
  overflow: hidden;
  border-radius: 50%;
  display: inline-block;
  border: none;
}
</style>
